<template>
  <div class="qty-box order-detail-quantity">
    <span class="val"> {{ deliveredVal }} {{ unit }} </span>
    <span class="small">{{ quantityPerUnit }}</span>
  </div>
</template>
<style lang="scss">
.qty-box.order-detail-quantity {
  width: 50%;
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  white-space: nowrap;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    color: white;
    background: $primary;
    font-weight: 600;
    font-size: 14px;
    width: 110px;
    padding: 2px 5px;
  }
  .small {
    margin-left: 3px;
  }
}
</style>
<script>
import productMixin from "~/mixins/product";
import CatalogService from "~/service/catalogService";

export default {
  name: "OrderDetailQuantity",
  props: {
    item: { type: Object, required: true },
    delivered: { type: Boolean, default: false, required: false }
  },
  data() {
    return {
      deliveredVal: null
    };
  },
  mixins: [productMixin],
  computed: {
    product() {
      return this.item.product;
    }
  },
  created() {
    if (this.delivered) {
      if (this.item.product.productInfos.TIPOLOGIA === "Sfuso") {
        //Handling floating point decimals issues
        let val = (this.item.deliveredWeight * 1000).toFixed(0);
        val = val * CatalogService.getMultiplier(this.item.product);
        val = val / 1000;
        this.deliveredVal = val;
      } else {
        this.deliveredVal = this.item.deliveredQuantity;
      }
    } else {
      this.deliveredVal = this.quantity;
    }
  }
};
</script>
